import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as Bowser from 'bowser';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';


@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    standalone: false
})
export class PdfViewerComponent implements OnInit {
 // pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  srcType: string;
  pdfData: Blob | string;
  downloadFileName: string;
  public zoom = '130';
  title = '';
  downLoadFile:boolean=false;
  

  @ViewChild('pdfViewer') public pdfViewer:PdfJsViewerComponent;
 // @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  //@ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;
  public page = 1;
  browser = Bowser.getParser(window.navigator.userAgent);
  public pageLabel: string;
  public displayPDF:boolean=true;
  constructor( private dialog: MatDialog,
    private dialogRef: MatDialogRef<PdfViewerComponent>,

    
    @Inject(MAT_DIALOG_DATA) data) { 
     // let url = "https://github.com/intbot/ng2-pdfjs-viewer/tree/master/sampledoc/pdf-sample.pdf"
      // E.g: http://localhost:3000/api/GetMyPdf
      // Please note, for remote urls to work, CORS should be enabled at the server. Read: https://enable-cors.org/server.html
   
     // pdfDefaultOptions.assetsFolder = 'assets';
      this.dialogRef.addPanelClass('pdf-viewer-dialog');
      this.dialogRef.updateSize('80vw', '75vh');
      this.dialogRef.disableClose = true;
      this.pdfData = data.pdfData;
      this.srcType = data.srcType;
      this.downloadFileName = data.downloadFileName;
      this.title = data.title;
      this.downLoadFile=data.downLoadFile===undefined?true:data.downLoadFile;
     
console.log(this.browser.getBrowser());
if(parseFloat(this.browser.getBrowser().version)>80){
  this.displayPDF=true;
}else{
  this.displayPDF=false
}
     // this.pdfViewer.pdfSrc=data.pdfData;
     // this.pdfViewerOnDemand.pdfSrc = data.pdfData; ; // pdfSrc can be Blob or Uint8Array
      //this.pdfViewerOnDemand.refresh();
      
    }

  ngOnInit(): void {
  }

  beforePrint(){
    document.title = this.downloadFileName;
  }
  afterPrint(){
   document.title = this.downloadFileName;
  }
  close(){
    this.dialogRef.close();
  }
}
